import PropTypes from 'prop-types';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import cx from 'classnames';
import { useBreakpoint } from '@app/hooks';
import {
  PAGE_BREAKPOINTS,
  FALLBACK_MOUNTAIN_IMAGE
} from '@app/constants/commonConstants';
import {
  THUMBNAIL_IMAGE_SIZE,
  THUMBNAIL_IMAGE_SIZE_TABLET,
  THUMBNAIL_POPUP_IMAGE_SIZE
} from '../../../RepairOptions/constants';
import styles from '../../../RepairOptions/PartsTable/customCells/cellStyles.module.scss';
import { useMemo } from 'react';

const KitPartImage = ({ item, className, isRightColumn }) => {
  const { imageURL, name } = item;
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);

  const tooltipPosition = useMemo(() => {
    if (!isMD) {
      return 'auto';
    }
    return isRightColumn ? 'left-start' : 'right-start';
  }, [isMD, isRightColumn]);

  return imageURL === FALLBACK_MOUNTAIN_IMAGE ? (
    <img
      src={FALLBACK_MOUNTAIN_IMAGE}
      width={THUMBNAIL_IMAGE_SIZE}
      height={THUMBNAIL_IMAGE_SIZE}
      loading="lazy"
      alt={name}
      className={cx(
        styles['table__image-size'],
        styles['table__fallBackImage-size'],
        className
      )}
    />
  ) : (
    <CatTooltip
      isInteractive
      position={tooltipPosition}
      data-testid="CatTooltip"
    >
      <>
        <button
          slot="trigger"
          className={cx(styles['container-image-button'], className)}
        >
          <img
            src={imageURL}
            width={isLG ? THUMBNAIL_IMAGE_SIZE : THUMBNAIL_IMAGE_SIZE_TABLET}
            height={isLG ? THUMBNAIL_IMAGE_SIZE : THUMBNAIL_IMAGE_SIZE_TABLET}
            loading="lazy"
            alt={name}
            data-testid="contentsImage"
          />
        </button>
        <img
          src={imageURL}
          width={THUMBNAIL_POPUP_IMAGE_SIZE}
          height={THUMBNAIL_POPUP_IMAGE_SIZE}
          loading="lazy"
          alt={name}
          data-testid="ToolTipImage"
        />
      </>
    </CatTooltip>
  );
};

KitPartImage.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    imageURL: PropTypes.string,
    name: PropTypes.string
  }),
  isRightColumn: PropTypes.bool
};

export default KitPartImage;
